/**
 * Returns a new array containing only uniq entries. Alias: *unique*
 * @this array<*>
 * @return {array<*>}
 * @example
 * import {uniq} from 'js-utils';
 * [1, 1, 2, 3, 3]::uniq(); // [1, 2, 3]
 */
export function uniq() {
	return this.filter((val, i, arr) => arr.indexOf(val) === i);
}
export {uniq as unique};

/**
 * Returns a new array containing the intersection between *this* and *arr*.
 * @this array<*>
 * @param {array<*>} arr the 2. array
 * @return {array<*>}
 * @example
 * import {intersection} from 'js-utils';
 * [1, 2, 3]::intersection([3, 2]); // [2, 3]
 */
export function intersection(arr) {
	return this.filter(val => arr.indexOf(val) !== -1);
}

/**
 * Checks if the array contains a value.
 * @this array<*>
 * @param {*} value value to search in the array
 * @return {boolean} true if value is in this
 * @example
 * import {contains} from 'js-utils';
 * [1, 2, 3]::contains(3); // true
 * [1, 2, 3]::contains(4); // false
 */
export function contains(val) {
	return this.indexOf(val) !== -1;
}


/**
 * Flat array map (similar to arrays in perl). This function flattens only one
 * level of array nesting.
 * @this array<*>
 * @param {arrayCallback} cb
 * @param {*} [thisArg] *this* to call *cb* with
 * @return {array<*>}
 * @example
 * import {flatMap} from 'js-utils';
 * [1, 2, 3]::flatMap(v => [v, 2 * v]); // [1, 2, 2, 4, 3, 6]
 */
export function flatMap(cb, thisArg) {
	const ret = [];

	this.forEach((v, i, arr) => {
		const r = thisArg::cb(v, i, arr);
		if (Array.isArray(r)) {
			ret.push.apply(ret, r); // no array spread due to overhead
		} else if (r !== null && r !== undefined) {
			ret.push(r);
		}
	});

	return ret;
}
